import Config from '@deezer/config';
import configContents from 'src/config/config.json';
export const config = new Config(configContents);
